import { BreadcrumbItem } from 'components/common/BBreadcrumb';
import { BreadcrumbsLocationData } from 'types/search.type';
import { slugifyText } from 'utils/slugify';
import { useLocale } from './useLocale';
import { DropdownOption } from 'types/types';
import { linkService } from 'services/LinkService';
import { getLocalePrefix } from 'utils/getLocalePrefix';

export function useBreadcrumbs() {
  const { locale } = useLocale();

  const baseBreadcrumbItem: BreadcrumbItem = {
    label: 'Teknevia',
    link: '/',
    isTranslatable: false,
  };

  const defaultBreadcrumbs: BreadcrumbItem[] = [baseBreadcrumbItem];

  const generateCategoryLinks = (
    category: DropdownOption<string>,
    location: BreadcrumbsLocationData | null
  ) => {
    const generatedBreadcrumbsArray: BreadcrumbItem[] = [
      {
        label: category.label,
        link: getLocalePrefix(locale) + category.value,
        isTranslatable: false,
      },
    ];

    if (location) {
      const labelKeys = ['cityName', 'regionName', 'harborName'];
      const slugKeys = ['citySlug', 'regionSlug', 'harborSlug'];
      const matchType = location.matchType;
      for (const idx in labelKeys) {
        const labelKey = labelKeys[idx] as keyof typeof location;
        const slugKey = slugKeys[idx] as keyof typeof location;

        const locationLabel = location[labelKey] + ' ' + category.label;
        const locationSlug = linkService.generateCategoryLink({
          locale,
          locationSlug:
            (location[slugKey] as string) ?? slugifyText(`${locationLabel}`),
          category: category.value,
        });

        const hasAnySameLabel = generatedBreadcrumbsArray.some(
          (item) => item.label === locationLabel
        );

        if (!hasAnySameLabel) {
          generatedBreadcrumbsArray.push({
            label: locationLabel,
            link: locationSlug,
            isTranslatable: false,
          });
        }
        if (labelKey.includes(matchType)) {
          break;
        }
      }
    }

    return generatedBreadcrumbsArray;
  };

  const generateOrganizationBreadcrumbs = (subPage?: BreadcrumbItem) => {
    return [
      baseBreadcrumbItem,
      {
        label: 'organizations:home.title',
        link: '/hizmetler',
        isTranslatable: true,
      },
      ...(subPage ? [subPage] : []),
    ];
  };

  return {
    defaultBreadcrumbs,
    onlyTekneViaBreadcrumb: defaultBreadcrumbs[0],
    generateCategoryLinks,
    generateOrganizationBreadcrumbs,
  };
}
